/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class NumericRangeDirectiveController {
        public static $inject: string[] = [ ];

        public configuring          : boolean = false;
        public type                 : string;
        public startRange           : any;
        public startRangeChoices    : any[];
        public endRange             : any;
        public endRangeChoices      : any[];
        public showEqChoice         : boolean;
        public onCancel             : any;
        public onClear              : any;
        public onApply              : any;
        public checkIsCancelDisabled: any;
        public checkIsClearDisabled : any;
        public checkIsApplyDisabled : any;

        constructor() {}

        public cancel() : void {
            if (this.onCancel && angular.isFunction(this.onCancel)) {
                this.onCancel();
            }
        }

        public clear() : void {
            if (this.onClear && angular.isFunction(this.onClear)) {
                this.onClear();
            }
        }

        public apply() : void {
            if (this.onApply && angular.isFunction(this.onApply)) {
                this.onApply();
            }
        }

        public isCancelDisabled () : boolean {

            if (this.checkIsCancelDisabled && angular.isFunction(this.checkIsCancelDisabled)) {
                return this.checkIsCancelDisabled();
            }

            return false;
        }

        public isClearDisabled () : boolean {

            if (this.checkIsClearDisabled && angular.isFunction(this.checkIsClearDisabled)) {
                return this.checkIsClearDisabled();
            }

            return false;
        }

        public isApplyDisabled () : boolean {

            if (this.checkIsApplyDisabled && angular.isFunction(this.checkIsApplyDisabled)) {
                return this.checkIsApplyDisabled();
            }

            return false;
        }
    }

    getDealerwareWebComponentsModule().controller('NumericRangeDirectiveController', NumericRangeDirectiveController);

    export class NumericRangeDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'NumericRangeDirectiveController';
        public controllerAs     : string    =   'vm';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/numeric_range/numeric_range_directive.html';
        public scope            : Object    =   {
            type                    : '=',
            startRange              : '=',
            startRangeChoices       : '=?',
            endRange                : '=',
            endRangeChoices         : '=?',
            showEqChoice            : '=?',
            onCancel                : '&',
            onClear                 : '&?',
            onApply                 : '&',
            checkIsCancelDisabled   : '&?',
            checkIsClearDisabled    : '&?',
            checkIsApplyDisabled    : '&?'
        };
    }

    getDealerwareWebComponentsModule().directive('dealerwareNumericRange',
        () => new NumericRangeDirective()
    );
 }
